import { OnboardingCategory } from '@/types/onboarding';
import { requestQuery } from '@/services/request';
import { coreOnboardingJobCategoriesRoute } from '@/modules/onboarding/domain/routes/onboardingRoutes';

// Locally, there is no categories (needs to run EE insert)
export const mockCategories = [
  {
    internalPictureURL: 'https://mktassets.majelan.audio/app_placeholders/Entertainment%203.png',
    items: [
      { order: '1', title: 'Crimes', user_tag: 'true crime' },
      { order: '2', title: 'Docus', user_tag: 'docus' },
      { order: '3', title: 'Comédie', user_tag: 'comédie' },
      { order: '4', title: 'Suspens', user_tag: 'suspens' },
      { order: '5', title: 'Jeunesse', user_tag: 'jeunesse' },
      { order: '6', title: 'Enquête', user_tag: 'enquete' },
      { order: '7', title: 'Séries', user_tag: 'séries' },
      { order: '8', title: 'Fiction', user_tag: 'fiction' },
      { order: '9', title: 'Espionnage', user_tag: 'espionnage' },
      { order: '10', title: 'Érotisme', user_tag: 'érotisme' },
    ],
    order: '1',
    title: 'Divertissement',
  },
  {
    internalPictureURL: 'https://mktassets.majelan.audio/app_placeholders/culture_icon.png',
    items: [
      { order: '1', title: 'Masterclass', user_tag: 'masterclass' },
      { order: '2', title: 'Biographie', user_tag: 'biographie' },
      { order: '3', title: 'Histoire', user_tag: 'histoire' },
      { order: '4', title: 'Art', user_tag: 'art' },
      { order: '5', title: 'Musique', user_tag: 'musique' },
      { order: '6', title: 'Design', user_tag: 'design' },
      { order: '7', title: 'Mode ', user_tag: 'mode ' },
      { order: '8', title: 'Cinéma', user_tag: 'cinéma' },
      { order: '9', title: 'Cuisine', user_tag: 'cuisine' },
      { order: '10', title: 'Sport', user_tag: 'sport' },
      { order: '11', title: 'Idées', user_tag: 'idées' },
      { order: '12', title: 'Inspiration', user_tag: 'inspiration' },
      { order: '13', title: 'Philosophie', user_tag: 'philosophie' },
    ],
    order: '2',
    title: 'Culture',
  },
  {
    internalPictureURL: 'https://mktassets.majelan.audio/app_placeholders/Head%203.png',
    items: [
      { order: '1', title: 'Psycho', user_tag: 'psychologie' },
      { order: '2', title: 'Santé mentale ', user_tag: 'santé mentale ' },
      { order: '3', title: 'Sommeil ', user_tag: 'sommeil ' },
      { order: '4', title: 'Méditation', user_tag: 'méditation' },
      { order: '5', title: 'Sexualité', user_tag: 'sexualité' },
      { order: '6', title: 'Stress', user_tag: 'stress' },
      { order: '7', title: 'Confiance', user_tag: 'confiance' },
      { order: '8', title: 'Amour', user_tag: 'amour' },
      { order: '9', title: 'Bonheur', user_tag: 'bonheur' },
      { order: '10', title: 'Déconnexion ', user_tag: 'déconnexion ' },
      { order: '11', title: 'Émotions', user_tag: 'émotions' },
      { order: '12', title: 'Anxiété', user_tag: 'anxiété' },
      { order: '13', title: 'Reconversion', user_tag: 'reconversion' },
      { order: '14', title: 'Fitness', user_tag: 'fitness' },
      { order: '15', title: 'Nutrition', user_tag: 'nutrition' },
      { order: '16', title: 'Relations', user_tag: 'relations' },
      { order: '17', title: 'Yoga', user_tag: 'yoga' },
      { order: '18', title: 'Santé', user_tag: 'santé' },
      { order: '19', title: 'ASMR', user_tag: 'asmr' },
      { order: '20', title: 'Ambiances', user_tag: 'ambiances' },
      { order: '21', title: 'Pleine conscience', user_tag: 'pleine conscience' },
    ],
    order: '3',
    title: 'Bien-être',
  },
  {
    internalPictureURL: 'https://mktassets.majelan.audio/app_placeholders/Kids%203.png',
    items: [
      { order: '1', title: 'Contes', user_tag: 'contes' },
      { order: '2', title: 'Aventure', user_tag: 'découverte' },
      { order: '3', title: 'Au lit', user_tag: 'au lit' },
      { order: '4', title: 'Éducation', user_tag: 'éducation' },
      { order: '5', title: '3-5 ans', user_tag: '3-5 ans' },
      { order: '6', title: '6-8 ans', user_tag: '6-8 ans' },
      { order: '7', title: '9-11 ans', user_tag: '9-11 ans' },
    ],
    order: '4',
    title: 'Jeunesse',
  },
  {
    internalPictureURL: 'https://mktassets.majelan.audio/app_placeholders/Flash%203.png',
    items: [
      { order: '1', title: 'Gestion du temps', user_tag: 'gestion du temps' },
      { order: '2', title: 'Prise de parole', user_tag: 'prise de parole' },
      { order: '3', title: 'Management', user_tag: 'management' },
      { order: '4', title: 'Créativité', user_tag: 'créativité' },
      { order: '5', title: 'Performance', user_tag: 'performance' },
      { order: '6', title: 'Carrière ', user_tag: 'carrière ' },
      { order: '7', title: 'Entrepreneuriat', user_tag: 'entrepreneuriat' },
      { order: '8', title: 'Efficacité ', user_tag: 'efficacité ' },
      { order: '9', title: 'Dev perso', user_tag: 'dev perso' },
      { order: '10', title: 'Leadership', user_tag: 'leadership' },
    ],
    order: '5',
    title: 'Productivité',
  },
  {
    internalPictureURL: 'https://mktassets.majelan.audio/app_placeholders/Business%203.png',
    items: [
      { order: '1', title: 'Business', user_tag: 'business' },
      { order: '2', title: 'Politique', user_tag: 'politique' },
      { order: '3', title: 'Sciences', user_tag: 'sciences' },
      { order: '4', title: 'Innovation', user_tag: 'innovation' },
      { order: '5', title: 'Écologie', user_tag: 'écologie' },
      { order: '6', title: 'Technologie', user_tag: 'technologie' },
      { order: '7', title: 'Féminisme', user_tag: 'féminisme' },
      { order: '8', title: 'Spiritualité', user_tag: 'spiritualité' },
      { order: '9', title: 'Économie', user_tag: 'économie' },
      { order: '10', title: 'Actualité', user_tag: 'actualité' },
      { order: '11', title: 'Engagement', user_tag: 'engagement' },
    ],
    order: '6',
    title: 'Société',
  },
];

export const getOnboardingJobCategories = async () => {
  try {
    const response = await requestQuery<{ categories: OnboardingCategory[] }>({
      url: coreOnboardingJobCategoriesRoute,
    });
    return response.categories;
  } catch (e) {
    return mockCategories;
  }
};
